import { FilterNames } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';

export const isFiltersContainStatusChanged = (statusList: string[]): boolean => {
    if (statusList?.length > 0) {
        const statusChangedOptionSelected = statusList.find((filter) => filter === 'INTERIM_CHANGED');
        return Boolean(statusChangedOptionSelected);
    }
    return false;
};

export const createSpecialFiltersPayload = (FiltersObj) => {
    const resFilters: { data: (number | string)[]; name: string }[] = [];
    const flags: Record<string, any> = {};

    const handleDateFilter = (value, filterName, flagName) => {
        if (!value) return;

        switch (typeof value) {
            case 'string':
                resFilters.push({ data: [], name: filterName });
                flags[flagName] = value;
                break;

            default:
                resFilters.push({ data: value, name: filterName });
        }
    };

    handleDateFilter(FiltersObj?.finishDate?.value, FilterNames.END_DATE_CARD_BOARD, 'endDatesRange');

    handleDateFilter(FiltersObj?.startDate?.value, FilterNames.START_DATE_CARD_BOARD, 'startDatesRange');

    handleDateFilter(
        FiltersObj?.baselineFinishDate?.value,
        FilterNames.BASELINE_END_DATE_CARD_BOARD,
        'baselineEndDatesRange',
    );

    handleDateFilter(
        FiltersObj?.baselineStartDate?.value,
        FilterNames.BASELINE_START_DATE_CARD_BOARD,
        'baselineStartDatesRange',
    );

    if (FiltersObj?.hasComments?.value) {
        if (FiltersObj?.hasComments?.commenter) {
            resFilters.push({
                data: [FiltersObj.hasComments.commenter.value],
                name: FilterNames.COMMENTER_CARD_BOARD,
            });
        }

        if (FiltersObj?.hasComments?.mentioned) {
            resFilters.push({
                data: [FiltersObj.hasComments.mentioned.value],
                name: FilterNames.MENTIONED_USER_CARD_BOARD,
            });
        }

        handleDateFilter(FiltersObj?.hasComments?.value, FilterNames.COMMENT_CARD_BOARD, 'commentRange');
    }

    if (FiltersObj?.riskIndicators) {
        FiltersObj.riskIndicators.forEach((riskIndicator) => {
            resFilters.push({ data: ['1'], name: riskIndicator });
        });
    }

    if (FiltersObj?.searchByName) {
        if (FiltersObj.searchByName.value) {
            resFilters.push({
                data: [FiltersObj.searchByName.value],
                name: FilterNames.TEXT_SEARCH_CARD_BOARD,
            });
        }

        if (FiltersObj.searchByName.isAdvancedTextSearch) {
            flags.isAdvancedTextSearch = FiltersObj.searchByName.isAdvancedTextSearch;
        }
    }

    return {
        filters: resFilters,
        flags,
    };
};
